$('.hj-baker-testimonial').slick({
      dots: false,
      infinite: true,
      autoplay:true,
      autoplaySpeed:5000,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true
});

$('.hj-baker-social-images').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});

$('.hj-recipe-review-content').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows:true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
  ]
});

	const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");

	accordionItemHeaders.forEach(accordionItemHeader => {
   accordionItemHeader.addEventListener("click", event => {
    
      accordionItemHeader.classList.toggle("active");
     const accordionItemBody = accordionItemHeader.nextElementSibling;
     if(accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
     }
     else {
       accordionItemBody.style.maxHeight = 0;
     }
    
   });
});

$('.hj-features-content-slide').slick({
      dots: true,
      infinite: true,
      autoplay:true,
      autoplaySpeed:4000,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true
});

$('.hj-card-product-slider').slick({
      dots: true,
      infinite: true,
      autoplay:false,
      autoplaySpeed:5000,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
});

 // $(".recipe-vdo-img-btn").on("click", function() {
 //   $('.recipe-vdo-img-btn img').css("display","none");
 //     });

$(document).ready(function(){
  $(".recipe-vdo-img-btn").click(function(){
    $(this).hide();
  });
});
